import { DeleteCircleIcon } from './DeleteCircleIcon';

/**
 * author: Austin Andrews
 * id 1158F80B-E934-4E74-A4C6-7750BDCC409E
 * name delete-circle
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/delete-circle.svg
 * tags
 */
export const TrashCanCircleIcon = DeleteCircleIcon;
export default TrashCanCircleIcon